// extracted by mini-css-extract-plugin
module.exports =  {"destructive_withBackground":"InlineMessageDestructive-module__destructive_withBackground___ACTVX","destructive__icon":"InlineMessageDestructive-module__destructive__icon___uBRD9"};